
import React from "react";
import {connect} from 'dva';
import {framework_tool, component_tool} from '@/tool'
import 'antd/dist/antd.css';
import {modelUtils} from "@/utils";
const {WizContainer} = framework_tool;
import {ExportExcel} from '@/components/index'
let {WizSpin, WizTypography, WizModal} = component_tool;
const {Paragraph} = WizTypography;
class WizOrgSelect extends WizContainer {
    
    componentName = "WizOrgSelect";
    
  constructor(props) {
    super(props);
    this.state = {}
    this.chapterInfos = []
  }
  
  propsAndStateOnChange = {
    orgSelect: this._handleOrgSelect.bind(this),
  };
  _handleOrgSelect(nextProps, nextState) {
    let o = nextProps['orgSelect']
    if (o['success']) {
      let data = o['data'];
      let str = data['import'].toString().replace(/<br\/>/g, "\n")
      let info =data['infos']
      this.chapterInfos = info;
      if (this.props.callback) {
        this.props.callback(this.chapterInfos)
      }
      WizModal.success({
        title: '导入结果',
        content: <p style={{whiteSpace: "pre-line"}}>{str}</p>
      })
      return true;
    } else {
      wizNotice.error("导入数据出错，请联系相关人员")
      return false;
    }
  }


  _render() {
    let examId = this.props.examId;
    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
        <Paragraph>2、按照要求格式填写信息</Paragraph>,
        <Paragraph>3、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
      ]
    }
    let operateProps = {
      title: '组织批量导入',
      template: {
        label: '模版下载',
        fileName: '模版.xlsx',
        href: constants.files.excel_importOrg,
      }

    }
    let submit = (file, fileData) => {
      let { modalKey = '', isNotAuth = false } = this.props
      let apiPath = 'organization/orgSelect';
      this.doAction({
        path: apiPath,
        payload: {
          key: "orgSelect" + modalKey,
          apiParams: {
            isNotAuth,
            fileData
          }
        }
      });
    }
    let {organizationLoading} = this.props;
    return (
      <WizSpin tip={'文件上传中'} spinning={organizationLoading}>
        <ExportExcel
          infoProps={infoProps}
          operateProps={operateProps}
          submit={submit}
        />
      </WizSpin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {organization} = state;
  let {modalKey = ''} = ownProps

  const orgSelect = modelUtils.getModelEntity(organization, 'orgSelect' + modalKey);
  //获取loading的方式
  const load = modelUtils.getLoadingState(state, 'organization')
  return {
    orgSelect: orgSelect,
    ...load
  }
};

export default connect(mapStateToProps)(WizOrgSelect);